import { StyleSheet } from 'react-native'

import { publishEvent } from '@zet/analytics'
import { PressableWithIntent } from '@zet/common/components/pressableWithIntent'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { B5, XStack } from '@zet/design-system'
import { AnimatedNumber } from '@zet/feature-loyalty/screens/tierBenefits/animatedNumber'
import { currencyFormatConvertorRoundDown } from '@zet/feature-loyalty/utils'

import ZetCoinsFilled from '../../assets/svg/zetCoinsFilled.svg'
import { i18n } from '../../localization'

type CoinsWidgetProps = {
  totalPointsEarned?: number
  points?: number
}

const CoinsWidget = ({ totalPointsEarned, points }: CoinsWidgetProps) => {
  const { navigate } = useNavigation()

  const getSubHeading = () => {
    if (points && points !== totalPointsEarned) {
      return i18n.t('earningsCard.balance', {
        coins: currencyFormatConvertorRoundDown(points?.toFixed(0)),
      })
    } else {
      return i18n.t('loyaltyDetails.totalZetCoins')
    }
  }

  const navigateToCoinsLedger = () => {
    publishEvent('click_action', {
      item_name: 'coins_homepage',
      feature: 'coins_ledger',
      total_coins: totalPointsEarned,
    })
    navigate('loyaltyCoinsLedger')
  }

  return (
    <PressableWithIntent
      name="ZetCoins"
      className="rounded-lg p-3"
      style={styles.card}
      onPress={navigateToCoinsLedger}
    >
      <XStack className="mb-1 items-center">
        <ZetCoinsFilled />
        <AnimatedNumber
          animateToNumber={currencyFormatConvertorRoundDown(
            totalPointsEarned?.toFixed(0)
          )}
        />
      </XStack>
      <B5 className="text-grays-70 ml-1">{getSubHeading()}</B5>
    </PressableWithIntent>
  )
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#F3F7FE',
    width: '48%',
  },
})

export { CoinsWidget }
